import request from '../utils/request';

export function getCommandList(param) {
  return request({
      url: '/admin/search-command',
      method: 'GET',
      params: param
  })
}

export function addCommand(data) {
    return request({
        url: '/admin/command',
        method: 'POST',
        data
    })
}



export function saveCommand(data) {
    return request({
        url: '/admin/command/device/'+ data.id +'/command',
        method: 'PUT',
        data
    })
}

export function runCommand(id) {
    return request({
        url: '/admin/command/' + id+"/run",
        method: 'PUT'
    })
}

export function deleteCommand(id) {
  return request({
      url: '/admin/command/' + id,
      method: 'DELETE'
  })
}

export function setCommandIsValidate(id, is_validate) {
    return request({
        url: '/admin/command/'+id+'/is-validate/'+is_validate,
        method: 'PUT'
    })
}

export function getAllCommands() {
    return request({
        url: '/admin/commands-all',
        method: 'GET'
    })
}

